const state =
    {
        isXl: false,
        isLg: false,
        isSm: false,
        isXs: false,
        isMobile: false
    };

const mutations =
    {
        setViewPortSize(state, windowWidth)
        {
            if (windowWidth >= 1200){
                state.isXl = true;
                state.isLg = false;
                state.isSm = false;
                state.isXs = false;
                state.isMobile = false;
            }
            else if (windowWidth >= 992 && windowWidth < 1200){
                state.isXl = false;
                state.isLg = true;
                state.isSm = false;
                state.isXs = false;
                state.isMobile = false;
            }
            else if(windowWidth  >= 768 && windowWidth < 991){
                state.isXl = false;
                state.isLg = false;
                state.isSm = false;
                state.isXs = false;
                state.isMobile = true;
            }
            else if (windowWidth  >= 578 && windowWidth < 767){
                state.isXl = false;
                state.isLg = false;
                state.isSm = true;
                state.isXs = false;
                state.isMobile = true;
            }
            else if(windowWidth  < 577){
                state.isXl = false;
                state.isLg = false;
                state.isSm = false;
                state.isXs = true;
                state.isMobile = true;
            }
        },

    };

export default
{
    state,
    mutations
};
